/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import qs from 'qs';
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { EmptyState } from 'carbon-addons-iot-react';

const messages = defineMessages({
  contactAdministrator:
    'Check the URL or wait a few minutes and try again. If the problem persists, contact your application administrator',
  error: 'No data to show',
});
const NoMatch = ({ intl: { formatMessage }, location: { search } }) => {
  const { invalidURL, error: errorMessage, icon } = search ? qs.parse(search.replace('?', '')) : {};
  console.warn('invalidURL: ', invalidURL);
  return (
    <div className="no-match--empty-state">
      <EmptyState
        title={formatMessage(messages.error)}
        body={
          <div>
            <p>{errorMessage || formatMessage(messages.contactAdministrator)}</p>
          </div>
        }
        icon={icon || 'error'}
      />
    </div>
  );
};

export default injectIntl(NoMatch);
